// src/store/slices/design/uploadSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomFile } from 'types/dropzone';
import { FileRejection } from 'react-dropzone'; // Added the missing import

interface UploadState {
  acceptedFiles: CustomFile[];
  rejectedFiles: FileRejection[];
  overallProgress: number;
  isUploading: boolean;
}

const initialState: UploadState = {
  acceptedFiles: [],
  rejectedFiles: [],
  overallProgress: 0,
  isUploading: false
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setAcceptedFiles: (state, action: PayloadAction<CustomFile[]>) => {
      state.acceptedFiles = action.payload;
    },
    setRejectedFiles: (state, action: PayloadAction<FileRejection[]>) => {
      // Use mapping to ensure compatibility with Immer
      state.rejectedFiles = action.payload.map((rejection) => ({
        ...rejection,
        errors: rejection.errors.slice() // Clone the readonly array
      }));
    },
    setOverallProgress: (state, action: PayloadAction<number>) => {
      state.overallProgress = action.payload;
    },
    setIsUploading: (state, action: PayloadAction<boolean>) => {
      state.isUploading = action.payload;
    },
    resetUploadState: () => initialState
  }
});

export const { setAcceptedFiles, setRejectedFiles, setOverallProgress, setIsUploading, resetUploadState } = uploadSlice.actions;

export default uploadSlice.reducer;
